import { connectRouter } from 'connected-react-router'
import { History } from 'history'
import { combineReducers } from 'redux'

import { RootStoreModel } from '../store.model'

import { appConfigurationReducer } from './appConfiguration.reducer'
import { clientsReducer } from './clientsReducer'
import { confirmationDialogReducer } from './confirmationDialog.reducer'
import { layoutReducer } from './layout.reducer'
import { leadsReducer } from './leads.reducer'
import { notificationsReducer } from './notifications.reducers'
import { pagesStateReducer } from './pages.state.reducer'
import { pricingReducer } from './pricing.reducer'
import { processingReducer } from './processing.reducer'
import { profileReducer } from './profile.reducer'
import { tasksReducer } from './tasks.reducer'
import { tradesReducer } from './trades.reducer'

export const createRootReducer = (browserHistory: History) =>
  combineReducers<RootStoreModel>({
    router: connectRouter(browserHistory),
    profile: profileReducer,
    notifications: notificationsReducer,
    layout: layoutReducer,
    confirmationDialog: confirmationDialogReducer,
    appConfiguration: appConfigurationReducer,
    pagesState: pagesStateReducer,
    pricingState: pricingReducer,
    tradesState: tradesReducer,
    clientsState: clientsReducer,
    tasksState: tasksReducer,
    leadsState: leadsReducer,
    processing: processingReducer
  })
